export class PartnerGroupMemberWithoutEmployee {
  constructor(username, userType, joinDate, lastActivityDate) {
    this.username = username;
    this.userType = userType;
    this.joinDate = joinDate;
    this.lastActivityDate = lastActivityDate;
  }
}